"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = copy;
var clipboard_1 = __importDefault(require("clipboard"));
function copy(querySelector) {
    var copy = document.querySelectorAll(querySelector);
    if (copy.length > 0) {
        if (copy.length > 0) {
            new clipboard_1.default(querySelector);
        }
    }
}
